<!-- Header here-->
<!-- <div [ngClass]="{'blur': successModel}">
  <div class="container-fluid">
    <div class="row">
      <div class="row main headertop ht" [ngStyle]="{'display':isDisplay?'block':'none'}">
        <div class="row  width-alignment" *ngIf="product != 'corporate' && product != 'connect'">
          <div class="col-sm-12 compswitch ">
            <div class="switch relationship-tabs cswitch">
              <span class="relSubTab individuals" *ngIf="!isMarketplace">
                <a routerLink="/relationship/view/individuals" [class.active]="activeTab == 'individuals'"
                  (click)="tabReset('individuals')" class="optionone compone relation-sub-tabs">Individuals</a>
              </span>

              <span class="relSubTab business" *ngIf="!isMarketplace">
                <a routerLink="/relationship/view/business" [class.active]="activeTab == 'business'"
                  (click)="tabReset('business')" class="optiontwo relation-sub-tabs compotwoo compthree">Businesses</a>
              </span>

              <span class="relSubTab corporate" *ngIf="product == 'corporate' || product == 'lauditor' && !isMarketplace">
                <a routerLink="/relationship/view/corporate" [class.active]="activeTab == 'corporate'"
                  (click)="tabReset('corporate')" class="optiontwo relation-sub-tabs compotwoo compthree">Corporate</a>
              </span>

              <span class="relSubTab deleted" *ngIf="product == 'corporate' || product == 'lauditor' && !isMarketplace && role==='SU'">
                <a routerLink="/relationship/view/deleted" [class.active]="activeTab == 'deleted'"
                  (click)="tabReset('deleted')" class="optiontwo relation-sub-tabs compotwoo compthree sr">Deleted</a>
              </span>

              <span class="relSubTab individuals" *ngIf="product != 'content' && product != 'connect' && isMarketplace">
                <a routerLink="/relationship/view/marketplace" [class.active]="activeTab == 'marketplace'"
                  (click)="tabReset('marketplace')"
                  class="optionthree comptwo compotwoo relation-sub-tabs mrk">Marketplace</a>
              </span>
            </div>



          </div>
        </div>

        <div class="row" *ngIf="product == 'corporate'">
          <div class="col-sm-12 compswitch">
            <div class="switch relationship-tabs cswitch">
              <span class="relSubTab corporate">
                <a href="javascript: void(0)" (click)="tabReset('corporate')"
                  class="optionone compone relation-sub-tabs borderPix" [class.active]="activeTab == 'corporate'">External Counsels</a>
              </span>
            </div>

  </div>
</div>
      </div>
      <div class="arrowitem">
        <i *ngIf="isDisplay" class="fa fa-light fa-chevron-up" (click)="hideAndShow()"></i>
        <i *ngIf="!isDisplay" class=" fa fa-light fa-chevron-down" (click)="hideAndShow()"></i>
      </div>

    </div>
  </div>
</div> -->
<!-- Header ends here-->
<router-outlet></router-outlet>

 <div class="row main" *ngIf="!showModifyForm && !showMemberForm && !showExchange">
    <div class="container-fluid">

      <!-- Card: header + table + pagination -->
      <div class="table-container">

        <!-- Card Header Row -->
        <div class="page-header">
          <div class="header-content">
            <!-- <h2 class="page-title">List of {{activeTab | titlecase }} Relationships</h2> -->
            <h2 class="page-title">
              <!-- List of {{ activeTab === 'individuals' ? 'Individual' : (activeTab | titlecase) }} Relationships -->
              List of Relationships
            </h2>

            <div class="header-actions">
              <!-- Search -->
              <div class="search-wrapper">
                <input type="text" class="search-input" placeholder="Search Relationships..." [(ngModel)]="searchText"
                  (ngModelChange)="onSearchChange($event)" oninput="this.value = this.value.replace(/[^A-Za-z0-9 ]|^ /g,'')">
                <img src="assets/img/search.svg" class="search-icon">
              </div>

              <!-- Create Button -->
              <button class="btn-create" *ngIf="activeTab !== 'deleted'" (click)="onClick()">
                <i class="fa fa-plus me-2"></i> Add Relationships
              </button>
            </div>
          </div>
        </div>

        <!-- Active/Non-deleted tab content -->
        <ng-container *ngIf="activeTab !== 'deleted'">
        <!-- <div class="norel" *ngIf="relationshipList.length===0">There are no Relationship(s) under this category.</div> -->

        <div class="empty-state-container" *ngIf="relationshipList.length === 0">
          <!-- Search is server-side, so a non-matching keyword returns an empty
               list. Show "No results found" then, not the first-run empty state. -->
          <ng-container *ngIf="searchText?.trim(); else noRelationshipsYet">
            <img src="assets/img/e-relationship.png" class="empty-state-icon" alt="No results">
            <p class="empty-state-title">No results found</p>
            <p class="empty-state-subtitle">No relationships match your search. Try a different keyword.</p>
          </ng-container>
          <ng-template #noRelationshipsYet>
            <img src="assets/img/e-relationship.png" class="empty-state-icon" alt="No entries">
            <p class="empty-state-title">No Relationships Yet!</p>
            <p class="empty-state-subtitle">There are no Relationships under this category.</p>
          </ng-template>
        </div>

        <ng-container *ngIf="relationshipList.length>0">
          <!-- <table class="table table-borderless tblgrid">
            <thead>
              <tr class="theader">
                <th>
                  <p class="thheadname">Name</p>
                  <img src="assets/img/SORT.PNG" class="sortico" (click)="sortingFile('name')">
                </th>
                <th *ngIf="product != 'corporate' && !isMarketplace">
                  <p class="thheadname">Type</p>
                  <img src="assets/img/SORT.PNG" class="sortico" (click)="sortingFile('clientType')">
                </th>
                <th>
                  <p class="thheadname">Created On</p>
                  <img src="assets/img/SORT.PNG" class="sortico" (click)="sortingFile('created')">
                </th>
    
                <th *ngIf="activeTab != 'temporary'">
                  <p class="thheadname">Status</p>
                  <img src="assets/img/SORT.PNG" class="sortico" (click)="sortingFile('isAccepted')">
                </th>
    
                <th *ngIf="product == 'corporate'">
                  <!-- <p class="thheadname" *ngIf="product != 'corporate'">Groups</p> --
                  <p class="thheadname" *ngIf="product == 'corporate'">Departments</p>
                  <img src="assets/img/SORT.PNG" class="sortico" (click)="sortingFile('groups')">
                </th>
                <th></th>
              </tr>
            </thead> -->

          <div class="table-responsive-wrapper">
          <table class="head-table">
            <thead>
              <tr>
                <th>
                  <div class="th-content">
                    <span>Name</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('name')" alt="Sort">
                  </div>
                </th>
                <th *ngIf="product != 'corporate' && !isMarketplace">
                  <div class="th-content">
                    <span>Type</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('clientType')" alt="Sort">
                  </div>
                </th>
                <th>
                  <div class="th-content">
                    <span>Created On</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('created')" alt="Sort">
                  </div>
                </th>
                <th>
                  <div class="th-content" *ngIf="activeTab != 'temporary'">
                    <span>Status</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('isAccepted')" alt="Sort">
                  </div>
                </th>
                <th *ngIf="product == 'corporate'">
                  <div class="th-content">
                    <span>Departments</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('groups')" alt="Sort">
                  </div>
                </th>
                <!-- Cases Shared: Individual Relationships only (see PRD: Cases Shared feature) -->
                <th *ngIf="activeTab === 'individuals'">
                  <div class="th-content">
                    <span>Cases Shared</span>
                  </div>
                </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let rel of relationshipList | filter:searchText" class="table-row">
                <td class="title-head" (click)="exchangeInfo(rel)">{{rel.name}}</td>
                <td *ngIf="product != 'corporate' && !isMarketplace">{{rel.clientType}}</td>
                <td *ngIf="rel.created">{{rel.created}}</td>
                <td *ngIf="rel.created_on">{{rel.created_on}}</td>

                 <td *ngIf="activeTab != 'temporary'">
                  <div *ngIf="!rel.canAccept">
                    <!-- <div *ngIf="rel.status === 'inactive'">Inactive</div>
                    <div *ngIf="rel.isAccepted && rel.status !== 'inactive'">Active</div>
                    <div *ngIf="!rel.isAccepted && rel.status !== 'inactive'">Pending</div> -->
                    <button *ngIf="rel.status === 'inactive'" class="status-inactive">
                      Inactive
                    </button>
                    
                    <button *ngIf="rel.isAccepted && rel.status !== 'inactive'" class="status-active-word">Active
                    </button>
                    
                    <button *ngIf="!rel.isAccepted && rel.status !== 'inactive'" class="status-pending">
                      Pending
                    </button>
                  </div>
                  <!-- <button class="btn btn-primary" (click)="accept(rel)" [ngClass]="{'disabled': rel.isDisabled}" *ngIf=rel.canAccept>Accept</button> -->
                 
                   <button class="status-accept" (click)="accept(rel)" [ngClass]="{'disabled': rel.isDisabled}" *ngIf=rel.canAccept>
                    Accept
                  </button>

                </td>
              
               <td *ngIf="activeTab === 'deleted'">{{rel.deleted_by}}</td>
                <td *ngIf="product == 'corporate'">
                  <ul> <li *ngFor='let g of rel.filteredGroups'>{{g.name}}</li></ul>
                </td>

                <!-- Cases Shared: Individual Relationships only -->
                <td *ngIf="activeTab === 'individuals'" class="cases-shared-cell">
                  <a href="javascript:void(0)"
                     class="cases-shared-link"
                     *ngIf="getCasesSharedCount(rel) > 0"
                     (click)="openCasesShared(rel)"
                     (keyup.enter)="openCasesShared(rel)"
                     tabindex="0"
                     [attr.aria-label]="'View ' + getCasesSharedCount(rel) + ' cases shared by ' + rel.name">
                    {{ getCasesSharedLabel(rel) }}
                  </a>
                  <span class="cases-shared-na" *ngIf="getCasesSharedCount(rel) === 0">N/A</span>
                </td>

                <td class="action-cell">

                  <!-- Product based conditions for ActionBtn-->
                  <button mat-icon-button class="action-btn"
                    [matMenuTriggerFor]="isRestrictedPlan() ? null : actionMenu" (click)="checkPlan($event)"
                    *ngIf="activeTab !== 'deleted' && (product === 'lauditor' || product === 'corporate')"
                    [ngClass]="{'disabled':   rel.isDisabled || rel.isdisabled}">
                    <span class="action-dots">⋮</span>
                  </button>
                   <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu"
                    *ngIf="product === 'content' || product === 'connect'"
                    [ngClass]="{'disabled': rel.isDisabled || rel.isdisabled}">
                    <span class="action-dots">⋮</span>
                  </button>
                   <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu"
                    *ngIf="(role === 'TM' || role === 'GH') && product === 'corporate'"
                    [ngClass]="{'disabled': rel.isDisabled || rel.isdisabled}">
                    <span class="action-dots">⋮</span>
                  </button>
                   <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu"
                    *ngIf="activeTab === 'temporary'"
                    [ngClass]="{'disabled': rel.isDisabled || rel.isdisabled || !rel.canAccess}">
                    <span class="action-dots">⋮</span>
                  </button>
                  <!-- Product based conditions for ActionBtn-->

                  
                  <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
                    <button mat-menu-item *ngIf='rel.isAccepted && rel.status !== "inactive"' (click)="exchangeInfo(rel)">Exchange Information</button>
                    <button mat-menu-item *ngIf="rel.status ==='inactive'" (click)="activateRel(rel)">Activate Relationship</button>
                    <button mat-menu-item *ngIf="product == 'corporate'"  (click)="modifyGroups(rel)">Update Department Access</button>

                    <button mat-menu-item *ngIf="(role === 'SU' && product == 'lauditor' && (activeTab !== 'marketplace') && rel.isAccepted && rel.status !== 'inactive' && catsolo !== 'solo') "
                     (click)="modifyMembers(rel)">Add Team Member</button>
                    <!-- Cases Shared: Individual Relationships only -->
                    <button mat-menu-item *ngIf="activeTab === 'individuals' && getCasesSharedCount(rel) > 0" (click)="openCasesShared(rel)">Cases Shared</button>
                    <button mat-menu-item (click)="delrel(rel)">Delete Relationship</button>

                    <button mat-menu-item *ngIf="activeTab == 'temporary'" (click)="openConfirmBox(rel)">Send Invite</button>
                  </mat-menu>
                </td>

              </tr>

              <!-- <tr class="rone veiw-items" style="border: none;" *ngFor="let rel of relationshipList | filter:searchText"
                [class.actives]="highlight == rel.id || rel.isHighlighted">
                <td class="tabclass rname" (click)="exchangeInfo(rel)">{{rel.name}}</td>
                <td class="tabclass" *ngIf="product != 'corporate' && !isMarketplace">{{rel.clientType}}</td>
                <td class="tabclass" *ngIf="rel.created">{{rel.created}}</td>
                <td class="tabclass" *ngIf="rel.created_on">{{rel.created_on}}</td>
                <!--<td *ngIf="activeTab == 'temporary'">{{rel.created_by}}</td>--
    
                <td class="tabclass" *ngIf="activeTab != 'temporary'">
                  <div *ngIf="!rel.canAccept">
                    <div *ngIf="rel.status === 'inactive'">Inactive</div>
                    <div *ngIf="rel.isAccepted && rel.status !== 'inactive'">Active</div>
                    <div *ngIf="!rel.isAccepted && rel.status !== 'inactive'">Pending</div>
                  </div>
    
                  <button class="btn btn-primary" (click)="accept(rel)" [ngClass]="{'disabled': rel.isDisabled}"
                    *ngIf=rel.canAccept>Accept</button>
                </td>
                <td class="tabclass" *ngIf="activeTab === 'deleted'">{{rel.deleted_by}}</td>
                <td class="tabclass" *ngIf="product == 'corporate'">
                  <ul>
                    <li *ngFor='let g of rel.filteredGroups'>{{g.name}}</li>
                  </ul>
                  <!-- <ul>
                          <li *ngFor='let g of rel.groups'>{{g.name}}</li>
                        </ul> --
                </td>
                <td class="tabclass">
                  <div class="dropdown">
                 
                    <button type="button"
                      *ngIf="activeTab !== 'deleted' && (product === 'lauditor' || product === 'corporate')"
                      class="btn btn-primary dropdown-toggle actionbtn" data-bs-toggle="dropdown"
                      [ngClass]="{'disabled':   rel.isDisabled || rel.isdisabled}"> Action </button>
                    <!-- 
                        <button type="button" *ngIf="(role === 'TM' || role === 'GH') && rel.isAccepted && (product === 'lauditor')"
                        class="btn btn-primary dropdown-toggle actionbtn" data-bs-toggle="dropdown"
                        [ngClass]="{'disabled':  (rel.isDisabled || rel.isdisabled) || !rel.canAccess}"> Action </button> --
                    <button type="button" *ngIf="product === 'content' || product === 'connect'"
                      class="btn btn-primary dropdown-toggle actionbtn" data-bs-toggle="dropdown"
                      [ngClass]="{'disabled': rel.isDisabled || rel.isdisabled}"> Action </button>
                    <button type="button" *ngIf="(role === 'TM' || role === 'GH') && product === 'corporate'"
                      class="btn btn-primary dropdown-toggle actionbtn" data-bs-toggle="dropdown"
                      [ngClass]="{'disabled': rel.isDisabled || rel.isdisabled}"> Action </button>
    
                    <button type="button" *ngIf="activeTab === 'temporary'"
                      class="btn btn-primary dropdown-toggle actionbtn" data-bs-toggle="dropdown"
                      [ngClass]="{'disabled': rel.isDisabled || rel.isdisabled || !rel.canAccess}"> Action </button>
    
                    <ul class="dropdown-menu">
                      <li *ngIf='rel.isAccepted && rel.status !== "inactive"'>
                        <a class="dropdown-item" (click)="exchangeInfo(rel)">Exchange Information</a>
                      </li>
    
    
    
                      <li *ngIf="rel.status ==='inactive'">
                        <a class="dropdown-item" (click)="activateRel(rel)">Activate Relationship</a>
                      </li>
                      <li *ngIf="product == 'corporate'">
                        <!-- <a class="dropdown-item" (click)="modifyGroups(rel); scrollToTop()" *ngIf="product != 'corporate'"
                                href="javascript:void(0);">Modify Group Access</a> --
                        <a class="dropdown-item" (click)="modifyGroups(rel)" *ngIf="product == 'corporate'"
                          href="javascript:void(0);">Update Department Access</a>
                      </li>
                      <li
                        *ngIf="(role === 'SU' && product == 'lauditor' && (activeTab !== 'marketplace') && rel.isAccepted && rel.status !== 'inactive' && catsolo !== 'solo') ">
                        <a class="dropdown-item" (click)="modifyMembers(rel)">Add Team Member</a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="delrel(rel)">Delete Relationship</a>
                      </li>
                      <li *ngIf="activeTab == 'temporary'">
                        <a class="dropdown-item" (click)="openConfirmBox(rel)" href="javascript:void(0);">Send Invite</a>
                      </li>
                      <!-- <li>
                            <a class="dropdown-item" (click)="delrel(rel)"
                                href="javascript:void(0);">Delete Relationship</a>
                          </li> --
                    </ul>
                  </div>
                </td>
              </tr> -->

            </tbody>
          </table>
          </div>

          <!-- Pagination added-->
          <div class="nav-buttons" *ngIf="relationshipList.length>0 && activeTab !== 'deleted' && (!showModifyForm || !showMemberForm || !showExchange || !showDelConfirm)">
            <button class="prev" (click)="prev()" [disabled]="!relPrevCursor"> &lt;&lt; Prev </button>
            <button class="next" (click)="next()" [disabled]="!relNextCursor"> Next &gt;&gt;</button>
          </div>
          <!-- Pagination added-->

        </ng-container>
        </ng-container>

        <!-- Deleted tab content -->
        <ng-container *ngIf="activeTab === 'deleted'">
        <!-- <div class="norel" *ngIf="relationshipList.length===0">There are no Relationship(s) under this category.</div> -->
   
      <div class="empty-state-container" *ngIf="relationshipList.length === 0">
        <!-- Search is server-side, so a non-matching keyword returns an empty
             list. Show "No results found" then, not the first-run empty state. -->
        <ng-container *ngIf="searchText?.trim(); else noRelationshipsYetDeleted">
          <img src="assets/img/e-relationship.png" class="empty-state-icon" alt="No results">
          <p class="empty-state-title">No results found</p>
          <p class="empty-state-subtitle">No relationships match your search. Try a different keyword.</p>
        </ng-container>
        <ng-template #noRelationshipsYetDeleted>
          <img src="assets/img/e-relationship.png" class="empty-state-icon" alt="No entries">
          <p class="empty-state-title">No Relationships Yet!</p>
          <p class="empty-state-subtitle">There are no Relationships under this category.</p>
        </ng-template>
      </div>

        <div class="table-responsive-wrapper" *ngIf="relationshipList.length>0">
          <table class="head-table">
            <thead>
              <tr>
                <th>
                  <div class="th-content">
                    <span>Name</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('name')" alt="Sort">
                  </div>
                </th>
                <th>
                  <div class="th-content">
                    <span>Type</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('clientType')" alt="Sort">
                  </div>
                </th>
                <th>
                  <div class="th-content">
                    <span>Created On</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('created')" alt="Sort">
                  </div>
                </th>
                <th>
                  <div class="th-content">
                    <span>Deleted</span>
                    <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('isAccepted')" alt="Sort">
                  </div>
                </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let rel of relationshipList | filter:searchText"
                [class.actives]="highlight == rel.id || rel.isHighlighted" class="table-row">
                <td class="title-head" (click)="exchangeInfo(rel)">{{rel.name}}</td>
                <td>{{rel.clientType}}</td>
                <td>{{rel.created_on}}</td>
                <td>{{rel.deletedBy}}</td>

                <td lass="action-cell">
                  <div class="dropdown">
                    <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu"><span class="action-dots">⋮</span></button>
          
                    <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
                      <button mat-menu-item (click)="activateRel(rel)">Restore Relationship</button>
                      <button mat-menu-item (click)="deletePermanent(rel)">Delete Relationship</button>
                    </mat-menu>
                  </div>
                </td>
              </tr>
            </tbody>


            <!-- <tbody>
              <tr class="rone veiw-items" style="border: none;" [class.actives]="highlight == rel.id || rel.isHighlighted"
                *ngFor="let rel of relationshipList | filter:searchText">
                <td class="tabclass rname" (click)="exchangeInfo(rel)">{{rel.name}}</td>
    
                <td class="tabclass" *ngIf="rel.clientType">{{rel.clientType}}</td>
                <td class="tabclass">{{rel.created_on}}</td>
                <td class="tabclass">{{rel.deletedBy}}</td>
    
                <td class="tabclass">
                  <div class="dropdown">
                    <button type="button" class="btn btn-primary dropdown-toggle actionbtn" data-bs-toggle="dropdown">
                      Action </button>
    
                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" (click)="activateRel(rel)">Restore Relationship</a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deletePermanent(rel)">Delete Relationship</a>
                      </li>
                    </ul>
    
                  </div>
                </td>
              </tr>
            </tbody> -->
          </table>
        </div>
        </ng-container>

      </div><!-- /table-container -->
      
    </div>
  </div>





  <app-relationship-group-access *ngIf='showModifyForm' [activeTab]="activeTab"
                                 [reldata]='relationshipData' [showModifyForm]="showModifyForm"
                                 (event)='onChildEvent($event);onCloseEvent()'></app-relationship-group-access>
  <app-relationship-member-access *ngIf='showMemberForm' [activeTab]="activeTab"
                                 [reldata]='relationshipData' [showMemberForm]="showMemberForm"
                                 (event)='onChildEvent($event);onCloseEvent()'></app-relationship-member-access>
  <app-relationship-exchange *ngIf='showExchange' [activeTab]="activeTab"
                             [reldata]='relationshipData' [showExchange]="showExchange"
                             (event)='onChildEvent($event)'></app-relationship-exchange>
<div class="modal"
     *ngIf='showDelConfirm'
     style="display:block;" 
     tabindex="-1">
  <div class="modal-dialog">
      <div class="modal-content">
              <button type="button" class="btn-close cmod" data-bs-dismiss="modal" aria-label="Close" (click)="showDelConfirm = false;"></button>
          <div class="modal-body">
              <div class="alertpara">
                  <p class="alertparatxt">Confirmation</p>
                </div>
          </div>
          <!-- <div class="alertext" style="height:130px;">
            You will no longer be able to communicate and
            exchange information with <strong>{{selectedRel.name}}</strong>.
            Are you sure you want to end this digital relationship?
          </div> -->
            
          <div class="alertext alt2" *ngIf="activeTab === 'deleted' && role==='SU'"> Are you sure you want to delete the relationship request sent by<br> <strong>{{selectedRel.deletedBy}} </strong> ?</div>
          <div class="alertext" *ngIf="activeTab !== 'deleted'"> Are you sure you want to delete the relationship request sent to<br> <strong>{{selectedRel.name}}</strong> ?</div>

          <div class="alertbutton">
              <button class="btn btn-default  alertbtn alertbtnno"
                      data-bs-dismiss="modal"
                      (click)="showDelConfirm = false;"
                      aria-label="Close">No</button>
              <button class="btn btn-default alertbtn alertbtnyes"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      (click)="deleteRel()">Yes</button>
          </div>
      </div>
  </div>
</div>

<jw-modal id="delete-update-success" class="grp-update-success  alert-box">
    <div class="doc-iframe-scs-body ">
        <div class="container">
            <div class="row">
                <div class="alertbox">
                    <div class="close-x float-right" style="cursor: pointer;" (click)="closeModal('delete-update-success');">X</div>
                    <div class="alertpara">
                        <p class="alertparatxt"> Success</p>
                    </div>
                    <div class="alertext" *ngIf="selectedRel.isAccepted == false || selectedRel.status == 'inactive'">Congratulations!! You have successfully deleted the relationship of <strong>{{selectedRel.name}}</strong>.</div>  
                    <div class="alertext" *ngIf="selectedRel.isAccepted == true && selectedRel.status != 'inactive'">Relationship delete awaiting super user approval.</div>                 

                    <div class="center">
                      <button class="btn savecls" (click)="closeModal('delete-update-success')">OK</button>
                    </div>
                  </div>
            </div>
        </div>
    </div>
</jw-modal>

<jw-modal id="group-update-success" class="grp-update-success  alert-box">
    <div class="doc-iframe-scs-body ">
        <div class="container">
            <div class="row">
                <div class="alertbox">
                    <div class="close-x float-right" (click)="closeModal('group-update-success');">X</div>
                    <div class="alertpara">
                        <p class="alertparatxt"> Success</p>
                    </div>
                    <div class="alertext" *ngIf="product != 'corporate'">Congratulations!! You have successfully modified Group access for <strong>{{relationshipData.name}}</strong>.</div>                  
                    <div class="alertext" *ngIf="product == 'corporate'">Congratulations!! You have successfully modified Department access for <strong>{{relationshipData.name}}</strong>.</div>                  
                  </div>
            </div>
        </div>
    </div>
</jw-modal>
<!-- grid ends here -->
<div class="modal"
     *ngIf='showConfirm'
     style="display:block;" 
     tabindex="-1">
  <div class="modal-dialog">
      <div class="modal-content">
              <button type="button"
                      class="btn-close closebtn"
                      data-bs-dismiss="modal"(click)="showConfirm = false;" aria-label="Close"></button>
          <div class="modal-body">
              <div class="alertpara">
                  <p class="alertparatxt">Confirmation</p>
                </div>
          </div>
          <div class="alertext">
            Are you sure you want to send relationship invite to <br> <strong>{{selname}}</strong> ?
          </div>
          <div class="alertbutton">
              <button class="btn btn-default  alertbtn alertbtnno"
                      data-bs-dismiss="modal"
                      (click)="showConfirm = false;"
                      aria-label="Close">No</button>
              <button class="btn btn-default alertbtn alertbtnyes"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      (click)="send_invite_temp()">Yes</button>
          </div>
      </div>
  </div>
</div>

<ngx-spinner  size="medium" type="ball-clip-rotate"></ngx-spinner>